'use strict';

var toObject = require('../internals/to-object');

var aFunction = require('../internals/a-function');

var definePropertyModule = require('../internals/object-define-property');

var FORCED = require('../internals/forced-object-prototype-accessors-methods'); // `Object.prototype.__defineSetter__` method
// https://tc39.github.io/ecma262/#sec-object.prototype.__defineSetter__


if (require('../internals/descriptors')) {
  require('../internals/export')({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __defineSetter__: function __defineSetter__(P, setter) {
      definePropertyModule.f(toObject(this), P, {
        set: aFunction(setter),
        enumerable: true,
        configurable: true
      });
    }
  });
}